import { Tooltip, Text, TextProps } from '@wegroup/design-system';
import React from 'react';

interface Props {
  text: string;
}

const TruncatedHoverText: React.FC<
  React.PropsWithChildren<Props & TextProps>
> = ({ text, ...props }) => {
  return (
    <Tooltip label={text}>
      <Text color="text.gray" isTruncated maxW="40" {...props}>
        {text}
      </Text>
    </Tooltip>
  );
};

export default TruncatedHoverText;
